export default __webpack_public_path__ + "images/homefilter-b1ba6d1d0fea102ffc6c3a8a78c38a27.png";